import type BoltMetaArgs from 'types/BoltMetaArgs';
import type { CapiAuthorArchive } from 'types/capi/news';

import PageLoadErrorBoundary from '~/components/PageLoadErrorBoundary';
import useViewEvent from '~/hooks/useViewEvent';
import { getCanonicalUrl } from '~/utils/canonicalUrl';
import seo from '~/utils/seo';

import AuthorArchiveView from './AuthorArchiveView';

export default function AuthorArchiveRoute() {
  useViewEvent({ viewType: 'article_feed' });

  return <AuthorArchiveView />;
}

export const handle = {
  i18n: ['plp']
};

export function ErrorBoundary() {
  return <PageLoadErrorBoundary pageType="news" />;
}

type LoaderData = {
  pageData: CapiAuthorArchive;
};

export const meta = (args: BoltMetaArgs<LoaderData>) => {
  const { data } = args;

  if (!data) return [];

  const canonicalUrl = getCanonicalUrl(args, data.pageData.canonical_url);

  return seo.formatForMeta(canonicalUrl, data.pageData.seo);
};

export { loader } from './loader.server';
